// Externe Bibliotheken
import { useEffect } from 'react';

// Interne Module
import { checkIsAllowToBookService } from '@/_helper/checkAccess';
import * as storage from '@/_helper/storage';
import tracking from '@/_helper/tracking';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';
import Form from './Form';
import { DetectMultipleTabs } from '@/comp/multipleTabs/multipleTabs';

// Styles
import './transfer-cruise.scss';

const TransferCruise = () => {
    useEffect(() => {
        document.title = 'Transfer Kreuzfahrt' + window.$documentTitle;

        checkIsAllowToBookService('transferCruise');

        if (storage.get('bookingData') === null) {
            window.location.href = '#/';
        }

        document.querySelector('html').classList.add('redesign');

        tracking('loaded', 'transfer-cruise');
    }, []);

    return (
        <div className="page-transfer-cruise">
            <DetectMultipleTabs travelType="transfer-cruise" />

            <Header />

            <div className="content-wrapper">
                <div className="intro row txtC">
                    <h1 className="main-headline font-headline ">Wählen Sie Ihren Transfer für Ihre Kreuzfahrt</h1>
                </div>

                <div className="row">
                    <Form />
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default TransferCruise;
